export default __webpack_public_path__ + "b9905a1bd5d3d3eff5370f2427ba7f40.svg";